import styled, { css } from "styled-components";
import { colors } from "@teamrota/rota-design";

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 32px 0;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 0px;
  ${({ withBorder }) =>
    withBorder &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.neutral.light};
    `}
`;

export const StyledToolBarLeft = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: fill-available;
`;

export const StyledToolBarRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
`;

export const StyledFilterContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: fill-available;
  height: 100%;
  margin-right: 0;
`;

export const PublishContainerWrapper = styled.div`
  margin-left: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StatsWrapper = styled.div`
  display: flex;
`;

export const Stats = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: ${colors.nobel};

  & > span {
    font-size: 24px;
    font-weight: 400;
    color: ${colors.darkGrey};
    margin-right: 8px;
  }
`;
